/**
 * Frontend Currency Converter (INR to USD)
 * Target Market: /en-us
 */

(function() {
  // ==========================================
  // CONFIGURATION
  // ==========================================
  const INR_PER_USD = 95; // Exchange rate: 95 INR = 1 USD
  const EXCHANGE_RATE = 1 / INR_PER_USD;
  const TARGET_LOCALE = '/en-us';
  const CURRENCY_SYMBOL = '$';
  
  // Selectors mapped from your theme files (snippets/price.liquid, bundle-item.liquid, etc.)
  // We added generic wildcards (div[class*="price"]) to catch Sparq or any dynamic app blocks
  const PRICE_SELECTORS = [
    '.price-item',
    '.price-item--regular',
    '.price-item--last',
    '.compare-price',
    '.price__regular',
    '.price__sale',
    '.price',
    '.price--end',
    '.price-unit-price',
    'price-range .price-lable .price',
    '.number', // Added for unit prices
    '.money',
    '.amount',
    'div[class*="price"]',
    'span[class*="price"]',
    'p[class*="price"]',
    'del',
    's',
    'strike'
  ].join(', ');

  // ==========================================
  // LOGIC
  // ==========================================
  
  // Check if current URL path or hostname indicates the US market
  function isTargetMarket() {
    if (window._isTargetMarket === undefined) {
      const path = window.location.pathname.toLowerCase();
      const hostname = window.location.hostname.toLowerCase();
      
      const isUsPath = path.includes('/en-us') || path === '/us' || path.startsWith('/us/');
      const isUsDomain = hostname.startsWith('us.') || hostname.includes('-us.');
      
      // Also check Shopify global object if available
      const isUsCountry = window.Shopify && window.Shopify.country === 'US';
      const isUsLang = document.documentElement.lang.toLowerCase() === 'en-us';
      
      window._isTargetMarket = isUsPath || isUsDomain || isUsCountry || isUsLang;
    }
    return window._isTargetMarket;
  }

  // Extract pure number from an INR price string (e.g., "Rs. 1,000.00" -> 1000)
  function extractPrice(text) {
    if (!text) return null;
    // Remove commas (thousand separators)
    const noCommas = text.replace(/,/g, '');
    // Extract the first valid number (e.g., "Rs. 1000.00" -> "1000.00")
    const match = noCommas.match(/\d+(\.\d+)?/);
    if (!match) return null;
    
    const price = parseFloat(match[0]);
    return isNaN(price) ? null : price;
  }

  // Convert INR to USD and format to 2 decimal places with $ prefix
  function formatUSD(inrPrice) {
    const usdPrice = inrPrice * EXCHANGE_RATE;
    return `${CURRENCY_SYMBOL}${usdPrice.toFixed(2)}`;
  }

  // Process a single price element
  function convertElement(el) {
    // Skip if already converted to avoid double multiplication
    if (el.dataset.currencyConverted === 'true') return;
    
    // Avoid processing parent wrappers if they contain OTHER price elements
    // This prevents wiping out structure like unit prices
    const containsOtherPriceElement = Array.from(el.querySelectorAll(PRICE_SELECTORS)).length > 0;
    if (containsOtherPriceElement) return;

    // Handle data-price attribute (found in your bundle-item.liquid)
    if (el.hasAttribute('data-price')) {
       const originalPrice = parseFloat(el.getAttribute('data-price')) / 100; 
       if (!isNaN(originalPrice) && originalPrice > 0) {
          el.innerHTML = formatUSD(originalPrice);
          el.dataset.currencyConverted = 'true';
          return;
       }
    }

    // Direct text content replacement
    const originalText = el.textContent || el.innerText;
    const inrPrice = extractPrice(originalText);
    
    if (inrPrice !== null && inrPrice > 0) {
      // Save original INR price in a data attribute for debugging/reference
      el.dataset.originalInr = originalText;
      el.innerHTML = formatUSD(inrPrice);
      el.dataset.currencyConverted = 'true';
    }
  }

  // Find all elements and convert
  function convertPrices() {
    if (!isTargetMarket()) return;
    document.querySelectorAll(PRICE_SELECTORS).forEach(convertElement);
  }

  // Initialize and observe for dynamic changes
  function init() {
    if (!isTargetMarket()) return;

    // 1. Initial conversion on page load
    convertPrices();

    // 2. Set up MutationObserver to handle dynamically loaded content
    // This catches AJAX cart additions, variant changes, predictive search, and Quick View modals
    const observer = new MutationObserver((mutations) => {
      let shouldConvert = false;
      
      for (const mutation of mutations) {
        // If new elements are added to the DOM
        if (mutation.addedNodes.length > 0) {
          shouldConvert = true;
          break;
        }
        
        // If text changes inside an existing price element
        const targetEl = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
        
        if (targetEl && targetEl.matches && targetEl.matches(PRICE_SELECTORS)) {
          const text = targetEl.textContent || '';
          // If the text does not contain our currency symbol, it must have been updated by the theme to INR
          if (!text.includes(CURRENCY_SYMBOL)) {
            targetEl.dataset.currencyConverted = 'false';
            shouldConvert = true;
            break;
          }
        }
      }

      if (shouldConvert) {
        requestAnimationFrame(convertPrices);
      }
    });

    // Observe body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Execute
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
